export default function getTenantAndMailbox(targetMailbox: string) {
    const [mailbox = '', tenant = ''] = (targetMailbox || '').split('@');
    return { tenant, mailbox };
}
